import { ChannelSelectionService } from '@trustedshops/tswp-plugin-channel-management-contracts';
import { ChannelDto } from '@trustedshops/account-service-client';
import { inject } from '@trustedshops/tswp-core-composition';
import { AbstractPersistentEvent, Event } from '@trustedshops/tswp-core-common';
import {
  OrganizationalContainer,
  OrganizationalContainerSelectionService,
  TOKENS as MASTERDATA,
} from '@trustedshops/tswp-core-masterdata';

export class ChannelSelectionServiceImpl implements ChannelSelectionService {
  //#region Private Fields
  private readonly _selectedChannel: AbstractPersistentEvent<ChannelDto> =
    new AbstractPersistentEvent<ChannelDto>(null);
  private readonly _allChannels: AbstractPersistentEvent<ChannelDto[]> =
    new AbstractPersistentEvent<ChannelDto[]>([]);

  private _allContainers: OrganizationalContainer<ChannelDto>[] = [];
  //#endregion

  //#region Ctor
  public constructor(
    @inject(MASTERDATA.OrganizationalContainerSelectionService)
    private readonly _organizationalContainerSelector: OrganizationalContainerSelectionService
  ) {}
  //#endregion

  //#region Public Methods
  public async initialize(): Promise<void> {
    this._organizationalContainerSelector
      .getAllContainers<ChannelDto>()
      .subscribe((containers) => {
        if (!containers) {
          return;
        }

        this._allContainers = containers;
        this._allChannels.emit(containers.map((container) => container.info));
      });

    this._organizationalContainerSelector
      .getSelection<ChannelDto>()
      .subscribe((selection) => {
        this._selectedChannel.emit(selection?.[0]?.info ?? null);
      });
  }

  /**
   * Selects a channel.
   *
   * @param channel The channel to select.
   */
  public selectChannel(channel: ChannelDto): void {
    const container = this._allContainers.find((x) => x.id === channel.id);
    if (!container) {
      return;
    }

    this._organizationalContainerSelector.selectContainers([container]);
  }

  /**
   * Gets the currently selected channel
   *
   * @returns An event emitting as soon as the selcted channel changes.
   */
  public getSelectedChannel(): Event<ChannelDto> {
    return this._selectedChannel;
  }

  /**
   * Gets all channels available to the user (filtered by permission).
   *
   * @returns An event emitting as soon as the list of available containers changes.
   */
  public getAllChannels(): Event<ChannelDto[]> {
    return this._allChannels;
  }
  //#endregion
}
